// extracted by mini-css-extract-plugin
export default {"container":"update_container__ugB4p","tableToggle":"update_tableToggle__0krMA"};